import { useMemo } from 'react';
import { AllTiles } from './Summary';
import { BarChart } from 'shared-front-end';
import { displayLocaleDate, Entity, Row } from 'gossamer-unified';
import { SummaryResultRow } from 'cb-model';
import { List } from 'gossamer-front-end';

interface DateRange {
  start: Date;
  end: Date;
}

export const useDateRange = (): DateRange => {
  const dateRange = useMemo(() => {
    const lastMonday = new Date();
    lastMonday.setDate(lastMonday.getDate() - ((lastMonday.getDay() + 6) % 7));
    const twelveWeeksAgoLastMonday = new Date();
    twelveWeeksAgoLastMonday.setDate(twelveWeeksAgoLastMonday.getDate() - 84);
    return {
      start: twelveWeeksAgoLastMonday,
      end: lastMonday,
    };
  }, []);
  return dateRange;
};

interface SummaryChartTableProps {
  data: SummaryResultRow[];
  entity: Entity<Row>;
  period: DateRange;
  hideEvents?: boolean; // for users, events = bookings
}

export const SummaryChartTable = (props: SummaryChartTableProps) => {
  if (props.data.length === 0) {
    return <div>No data</div>;
  }
  const allTilesData = props.data.reduce((acc, row) => {
    acc.event_count = (acc.event_count || 0) + row.event_count;
    acc.booking_count = (acc.booking_count || 0) + row.booking_count;
    acc.post_event_booking_count = (acc.post_event_booking_count || 0) + row.post_event_booking_count;
    acc.attendance_count = (acc.attendance_count || 0) + row.attendance_count;
    return acc;
  }, {} as SummaryResultRow);
  const tableData = props.data.slice();
  tableData.reverse();
  return (
    <div>
      <p>
        for the period {displayLocaleDate(props.period.start)} to {displayLocaleDate(props.period.end)}
      </p>
      {!!allTilesData && <AllTiles data={allTilesData} hideEvents={props.hideEvents} />}
      <br />
      <BarChart
        rows={props.data}
        entity={props.entity}
        width={1000}
        height={400}
        lineFields={
          props.hideEvents
            ? ['booking_count', 'post_event_booking_count', 'attendance_count']
            : ['event_count', 'booking_count', 'post_event_booking_count', 'attendance_count']
        }
        xAxisField="week_commencing"
        xAxisTickFormatter={(wc: string) => {
          const date = new Date(wc);
          return date.getDate() + '/' + (date.getMonth() + 1);
        }}
        yAxisAllowDecimals={false}
      />
      <br />
      <List rows={tableData} entity={props.entity} />
    </div>
  );
};
